import { render, staticRenderFns } from "./dateTime.vue?vue&type=template&id=c2879b62&scoped=true"
import script from "./dateTime.vue?vue&type=script&lang=js"
export * from "./dateTime.vue?vue&type=script&lang=js"
import style0 from "./dateTime.vue?vue&type=style&index=0&id=c2879b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2879b62",
  null
  
)

export default component.exports